import type { OctFlash2026Variant } from '~/features/promotions/constants/oct-flash-2026';

import type { PromoCampaignSurfaceRenderers, RegisteredPromoCampaign } from '../types';

import { octFlash2026CampaignCore } from './campaign-core';
import { octFlash2026CampaignSurfaces } from './surfaces';

export { OCT_FLASH_2026_CAMPAIGN_ID, octFlash2026CampaignCore } from './campaign-core';

const octFlash2026PromoCampaignTyped = {
  ...octFlash2026CampaignCore,
  surfaces: octFlash2026CampaignSurfaces,
} satisfies PromoCampaignSurfaceRenderers<OctFlash2026Variant>;

export const octFlash2026PromoCampaign = octFlash2026PromoCampaignTyped as RegisteredPromoCampaign;
